import { SET_WORKERS, SET_WORKERS_UPDATED } from '../constants/WorkerConstants';

const initialState = {
  workers: {
    list: [],
    count: 0,
  },
  updated: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_WORKERS: {
      return {
        ...state,
        workers: action.payload,
        updated: false,
      };
    }

    case SET_WORKERS_UPDATED: {
      return {
        ...state,
        updated: action.payload,
      };
    }

    default:
      return state;
  }
}
